import React from "react";
import { Modal, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ImagePreviewModal = ({ imageUrl, open, onClose }) => {
  return (
    <Modal 
      open={open} 
      onClose={onClose}
      aria-labelledby="image-modal-title"
      className="d-flex align-items-center justify-content-center"
    >
      <Box
        className="bg-white rounded shadow-lg position-relative"
        sx={{
          width: "auto",
          maxWidth: "90vw",
          maxHeight: "90vh",
          m: 2,
          outline: "none"
        }}
      >
        {/* Close button */}
        <IconButton
          onClick={onClose}
          className="position-absolute"
          sx={{
            top: 8,
            right: 8,
            zIndex: 1,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.9)",
            }
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Image container */}
        <Box className="p-3">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt="Preview"
              className="img-fluid d-block mx-auto"
              style={{
                maxWidth: "100%",
                maxHeight: "80vh",
                objectFit: "contain"
              }}
            />
          ) : (
            <Box className="text-center py-5">
              <p className="text-muted mb-0">No image available</p>
            </Box>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default ImagePreviewModal;